import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 0 6px black',
    border: '0',
    background:
      'linear-gradient(to bottom right, rgb(56, 56, 56) 0%, rgb(60, 60, 60) 100%)',
    color: 'white',
    height: '60px',
    width: '60px',
    cursor: 'pointer',
    padding: '6px',
  },
  innerBox: {
    textAlign: 'center',
    border: '0.6px solid white',
    padding: '6px',
    borderRadius: '4px',
  },
  innerBoxActive: {
    borderColor: '#42f578',
    boxShadow: '0 0 3px white',
  },
  active: {
    color: '#42f578',
    boxShadow: '0 0 3px black',
  },
}));

interface IToggleButtonProps {
  active?: boolean;
  handleClick: () => void;
}

const ToggleButton: React.FC<IToggleButtonProps> = ({
  active = false,
  handleClick,
}) => {
  const classes = useStyles();
  const handleTouch = () => {
    handleClick();
  };
  return (
    <div
      className={`${classes.root} ${active ? classes.active : ''}`}
      onClick={handleTouch}
    >
      <div
        className={`${classes.innerBox} ${
          active ? classes.innerBoxActive : ''
        }`}
      >
        <span>TSD Enable</span>
      </div>
    </div>
  );
};

export default ToggleButton;
